//Core
import React from "react"

//Components
import Blocks from "../../components/Blocks"
import Cards from "../../components/Cards"
import Header from "./Header"
import Button from "../bonus/Button"

//Images
import first from "../../images/cashback/first.jpg"
import second from "../../images/cashback/second.jpg"
import third from "../../images/cashback/third.jpg"

const blocks = [
  {
    img: first,
    title: `Для кого ця акція?`,
    subtitle: [`Персонально для Вас`],
  },
  {
    img: second,
    title: `Який подарунок я отримаю?`,
    subtitle: [
      `Подвійний кешбек на всі покупки за кредитні кошти:`,
      `“Велика п’ятірка” - 4% в супермаркетах та АЗС / 2% на все інше`,
      `#PudraCard - 10% на одяг та взуття, 6% на косметику, парфумерію, б’юті-сферу та аптеки`,
      `Додатковий кешбек буде зараховано на бонусний рахунок до 15.01.20 за операції в грудні 2019 і до 15.02.20 за операції в січні 2020`,
    ],
  },
  {
    img: third,
    title: `Як отримати подарунок?`,
    subtitle: [
      `Протягом місяця використати кредитний ліміт за карткою Велика П’ятірка або #PudraCard на Вашу «щасливу суму», вказану в sms/viber`,
    ],
  },
]

//Custom style components

const backgroundCards = { backgroundColor: "rgba(187, 187, 187, 0.15)" }
const titleStyle = {
  fontWeight: "bold",
  fontFamily: "GothamProMedium",
}

const CashBack = ({ link }) => {
  return (
    <div>
      <Header></Header>
      <Blocks items={blocks}></Blocks>
      <Cards
        info={false}
        background={backgroundCards}
        titleStyle={titleStyle}
      ></Cards>
      <Button link={link}></Button>
    </div>
  )
}

export default CashBack
